import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";
import EditDepartmentForm from "./editDepartmentForm";
import { User } from "types";
import { useGetDepartmentById } from "api/department/getdepartmentid";

type EditDepartmentProps = {
  opened: boolean;
  departmentId?: string | null;
  onClose: () => void;
};

function EditDepartment({
  opened,
  onClose,
  departmentId,
}: EditDepartmentProps) {
  const {
    data: deptData,
    isLoading: isDeptLoading,
    isError: isDeptError,
  } = useGetDepartmentById(departmentId ?? undefined);
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      size="lg"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Edit Department"
        onClose={onClose}
        ariaLabel="Close create Department modal"
      />

      <EditDepartmentForm
        departmentId={departmentId}
        onClose={onClose}
        // deptData={deptData}
        // user={{} as User}
      />
    </Modal>
  );
}

export default EditDepartment;
